import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppRole, RoleName } from '@sa/app/shared/enums/user-roles';
import { UserAccessService } from '@sa/shared/services/user-access.service';

export const clientAdminRoleGuard: CanActivateFn = (route, state): boolean | Observable<boolean> => {
  const userAccessService = inject(UserAccessService);
  const router = inject(Router);

  const checkRole = (roleName: string | undefined): boolean => {
    if (roleName === RoleName.ClientAdmin) return true;
    router.navigate(['/no-auth']);
    return false;
  };

  const user = userAccessService.getUserRoleFeatures();
  if (user) return checkRole(user.userRole?.roleName);

  return userAccessService.getUserRoleFeaturesFromApi().pipe(
    map(apiUser => {
      if (!apiUser) {
        router.navigate(['/no-auth']);
        return false;
      }
      return checkRole(apiUser.userRole?.roleName);
    })
  );
};
